export default {
  documentRef: null,
  employeeId: "N/A",
  location: "N/A",
  timestamp: new Date(),
};
